// extracted by mini-css-extract-plugin
export default {"layout":"BreadcrumbLayout_layout__N6TK4","breadcrumb":"BreadcrumbLayout_breadcrumb__BzzCl"};